<template>
  <div class="cards__pagination Pagination">
    <div
      class="Pagination__chevron Pagination__chevron_left"
      v-if="isFirstPage"
      @click="switchPage(prevPage)"
    >
      <svg
        width="11"
        height="9"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.29249 0.457466C5.56911 0.734087 5.56911 1.18258 5.29249 1.4592L2.25169 4.5L5.29249 7.5408C5.56911 7.81742 5.56911 8.26591 5.29249 8.54253C5.01587 8.81916 4.56738 8.81916 4.29076 8.54253L0.749092 5.00087C0.472471 4.72425 0.472471 4.27575 0.749092 3.99913L4.29076 0.457466C4.56738 0.180845 5.01587 0.180845 5.29249 0.457466Z"
          fill="#2979FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.2508 0.457466C10.5274 0.734087 10.5274 1.18258 10.2508 1.4592L7.21003 4.5L10.2508 7.5408C10.5274 7.81742 10.5274 8.26591 10.2508 8.54253C9.97421 8.81916 9.52571 8.81916 9.24909 8.54253L5.70743 5.00087C5.4308 4.72425 5.4308 4.27575 5.70743 3.99913L9.24909 0.457466C9.52571 0.180845 9.97421 0.180845 10.2508 0.457466Z"
          fill="#2979FF"
        />
      </svg>
    </div>
    <div class="Pagination__middle">
      <ul class="Pagination__pages Pages">
        <li class="Pages__page Pages__page_edge" v-if="firstPage">
          <a href="#" @click.prevent="switchPage(1), scrollUp()">1</a>
        </li>

        <li
          class="Pages__page"
          :class="{ pages_current: current == page }"
          v-for="page in pages"
          :key="page"
        >
          <a href="#" @click.prevent="switchPage(page), scrollUp()">{{
            page
          }}</a>
        </li>

        <li class="Pages__page Pages__page_edge" v-if="lastPage">
          <a href="#" @click.prevent="switchPage(totalPages), scrollUp()">{{
            totalPages
          }}</a>
        </li>
      </ul>
    </div>
    <div
      class="Pagination__chevron Pagination__chevron_right"
      v-if="isLastPage"
      @click="switchPage(nextPage)"
    >
      <svg
        width="11"
        height="9"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.70755 0.457466C5.98417 0.180845 6.43266 0.180845 6.70928 0.457466L10.2509 3.99913C10.5276 4.27575 10.5276 4.72425 10.2509 5.00087L6.70928 8.54253C6.43266 8.81916 5.98417 8.81916 5.70755 8.54253C5.43093 8.26591 5.43093 7.81742 5.70755 7.5408L8.74835 4.5L5.70755 1.4592C5.43093 1.18258 5.43093 0.734087 5.70755 0.457466Z"
          fill="#2979FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.749214 0.457466C1.02584 0.180845 1.47433 0.180845 1.75095 0.457466L5.29262 3.99913C5.56924 4.27575 5.56924 4.72425 5.29262 5.00087L1.75095 8.54253C1.47433 8.81916 1.02584 8.81916 0.749214 8.54253C0.472593 8.26591 0.472593 7.81742 0.749214 7.5408L3.79001 4.5L0.749214 1.4592C0.472593 1.18258 0.472593 0.734087 0.749214 0.457466Z"
          fill="#2979FF"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  name: "Pagination",
  props: {
    current: {
      type: Number,
      default: 1,
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    },
    perPage: {
      type: Number,
      default: 1,
      required: true
    },
    range: {
      type: Number,
      default: 1,
      required: true
    }
  },
  computed: {
    pages() {
      let pages = [];

      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i);
      }

      return pages;
    },
    firstPage() {
      return this.rangeStart !== 1;
    },
    lastPage() {
      return this.rangeEnd < this.totalPages;
    },
    rangeStart() {
      let start = this.current - this.range;
      return start > 0 ? start : 1;
    },
    rangeEnd() {
      let end = this.current + this.range;
      return end < this.totalPages ? end : this.totalPages;
    },
    totalPages() {
      return Math.ceil(this.total / this.perPage);
    },
    isFirstPage() {
      return this.current > 1;
    },
    isLastPage() {
      return this.current < this.totalPages;
    },
    nextPage() {
      return this.current + 1;
    },
    prevPage() {
      return this.current - 1;
    }
  },
  methods: {
    ...mapMutations(["scrollUp"]),
    ...mapActions(["fetchCards"]),
    async switchPage(page) {
      this.$router
        .push(`${this.$route.meta.description.to}?page=${page}`)
        .catch(e => e);
      await this.fetchCards({
        API: this.$route.meta.API,
        page: page || this.$route.query.page
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.Pagination {
  display: flex;
  justify-content: center;

  &__chevron {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1.5px solid $aux_bg;
    border-radius: 5px;
    transition: all 0.2s;

    &_left {
      margin: 0 10px 0 0;
    }

    &_right {
      margin: 0 0 0 10px;
    }

    &:hover {
      background-color: $aux_bg;

      svg {
        path {
          fill: $sec_c;
        }
      }
    }
  }

  &__middle {
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: $min_md) {
    &__chevron {
      width: 34px;
      height: 34px;
    }
  }

  @media screen and (max-width: $max_sm) {
    &__chevron {
      width: 24px;
      height: 24px;
    }
  }
}

.Pages {
  display: flex;

  &__page {
    margin: 0 4px;

    &_edge {
      margin: 0 15px;
    }

    a {
      display: inline-block;
      font-weight: $b_fw;
      color: $aux_c;
      text-align: center;
      border: 1.5px solid $aux_bg;
      border-radius: 5px;
      transition: background-color 0.2s;

      &:hover {
        color: $sec_c;
        background-color: $aux_bg;
      }
    }
  }

  &__dots {
    display: flex;
    align-items: flex-end;
    font-weight: $bl_fw;
    color: $aux_c;

    span {
      white-space: nowrap;
    }
  }

  @media screen and (min-width: $min_md) {
    &__page {
      a {
        width: 34px;
        height: 34px;
        font-size: 14px;
        line-height: 34px;
      }
    }

    &__dots {
      margin: 0 6px;
    }
  }

  @media screen and (max-width: $max_sm) {
    &__page {
      a {
        width: 24px;
        height: 24px;
        font-size: 12px;
        line-height: 24px;
      }
    }

    &__dots {
      margin: 0 2px;
    }
  }
}

.pages_current {
  a {
    color: $sec_c;
    background-color: $aux_bg;
  }
}
</style>
